import React, { useEffect, useRef, useState } from 'react'
import './DiscrepancyChat.scss'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { sendMessage } from '../../redux/actions/CvAnalysisAction'
import ButtonSpinner from '../ReusableComponents/ButtonSpinner'


const ValianttLogo = <svg xmlns='http://www.w3.org/2000/svg' width='1.5rem' height='1.5rem' viewBox='0 0 38 35' fill='none'>
  <path d='M11.2417 11.1353L19.3721 24.8824L16.6128 29.6067L0 0H27.658L18.8726 16.6374L15.5566 11.1353H11.2417Z' fill='url(#paint0_linear_14263_90506)'/>
  <path d='M37.7207 0L19.5358 34.814L16.6128 29.6067L19.372 24.8824L32.3004 0H37.7207Z' fill='url(#paint1_linear_14263_90506)'/>
  <path d='M19.3721 24.8824L16.6128 29.6067L0 0H4.68336L11.2417 11.1353L19.3721 24.8824Z' fill='url(#paint2_linear_14263_90506)'/>
  <defs>
    <linearGradient id='paint0_linear_14263_90506' x1='252.714' y1='-0.951727' x2='237.11' y2='70.3594' gradientUnits='userSpaceOnUse'>
      <stop stopColor='#08A6E0' />
      <stop offset='0.34' stopColor='#0990DF'/>
      <stop offset='0.61' stopColor='#0149D6'/>
      <stop offset='1' stopColor='#1B1464'/>
    </linearGradient>
    <linearGradient id='paint1_linear_14263_90506' x1='41.5034' y1='29.6476' x2='43.3644' y2='-14.0916' gradientUnits='userSpaceOnUse'>
      <stop stopColor='#08A6E0' />
      <stop offset='0.49' stopColor='#0990DF'/>
      <stop offset='0.69' stopColor='#0149D6'/>
      <stop offset='0.99' stopColor='#1B1464'/>
    </linearGradient>
    <linearGradient id='paint2_linear_14263_90506' x1='0' y1='16.8666' x2='230.099' y2='16.8666' gradientUnits='userSpaceOnUse'>
      <stop stopColor='#08A6E0' />
      <stop offset='0.49' stopColor='#0990DF'/>
      <stop offset='0.82' stopColor='#0149D6'/>
      <stop offset='1' stopColor='#1B1464'/>
    </linearGradient>
  </defs>
</svg>

const DiscrepancyChat = ({ShowResume, setShowResume, ShowDiscrepancyChat, setShowDiscrepancyChat, chatDetails, Trigger, setTrigger}) => {
  const chatRef = useRef(null);
  const dispatch = useDispatch();
  const [Completed, setCompleted] = useState(false);
  const [Messages, setMessages] = useState([]);
  const [MessageInput, setMessageInput] = useState('');
  const SendingMessage = useSelector((state) => state.sendMessage?.loading);
  const IsMaster = localStorage.getItem('IsMaster') === '1' ? true : false

  useEffect(() => {
    setMessages([...chatDetails?.message]);
    setCompleted(chatDetails?.is_discrepancy_closed === 1 ? true : false)
  },[chatDetails])

  useEffect(() => {
    if(chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  })

  const convertDateFormat = (dateStr) => {
    const date = new Date(dateStr);
    // Format the date as DD/MM/YYYY
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    // Format the time as h:mmam/pm
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}${ampm}`;
    return formattedDate
  }

  const formatUserName = (name) => {
    const slicedName = name.split('_')[0];
    const properCaseName = slicedName.charAt(0).toUpperCase() + slicedName.slice(1).toLowerCase();
    return properCaseName
  }

  const renderMessage = (message, idx) => {
    const Sender = message?.is_admin === 1 ? 'Valiantt Info' : message?.company_name
    const UserName = message?.sender_username && formatUserName(message?.sender_username)
    const Time = message?.time && convertDateFormat(message.time)
    const msgText = message?.message
    const VendorLogo = localStorage.getItem('ClientInfoID_Logo')
    const VendorInitial = localStorage.getItem('client_username')?.[0]

    return (
      <div className={`MessageSec ${Sender === 'Valiantt Info' ? 'Sender' : 'Receiver'}`} key={idx}>
        <div className='LogoMessage'>
          {message?.is_admin === 1 ?
            <>
              {/* <span className='Logo'>{ValianttLogo}</span> */}
              <span className='Logo'>
                <span className='Initial'>{UserName[0]}</span>
              </span>
              <div className='Message'>
                <span className='UserName'>{UserName}</span>
                <span className='msgText'>{msgText}</span>
              </div>
            </>
            :
            <>
              <div className='Message'>
                <span className='UserName'>{UserName}</span>
                <span className='msgText'>{msgText}</span>
              </div>
              <span className='Logo'>
                {VendorLogo ? 
                  <img src={VendorLogo} alt='' draggable={false}/>
                  :
                  <span className='Initial'>{VendorInitial}</span>
                }
              </span>
            </>
          }
        </div>
        <span className='Time'>{Time}</span>
      </div>
    )
  }

  const submitMessage = () => {
    if(MessageInput?.trim()) {
      const currentDate = new Date();
      const SentTime = Date.now()
      const Messagedata = {
        "time": SentTime,
        "message": MessageInput,
        "is_admin": 0,
        "admin_client": "",
        "company_name": "",
        "verifier_admin": "",
        "sender_username": localStorage.getItem('client_username')
      }
      
      setMessages((prev) => [...prev, Messagedata])

      const data = {
        cv_analysis_id: chatDetails?.cv_analysis_id,
        message: MessageInput,
        is_admin: 0
      }
      
      const successFn = (response) => {
        console.log(response?.data)
        setTrigger(!Trigger)
      };
      
      const failureFn = (error) => {
        console.error("sendMessage failed", error);
      };
      
      dispatch(sendMessage({ data, successFn, failureFn }));

      setMessageInput('')
    }
    else {
      alert('Message should not be empty...')
    }
  }

  return (
    <div className='DiscrepancyChat'>
      <header>
        <h3 title={`${chatDetails?.display_name} - ${chatDetails?.company_college_name} (${chatDetails?.start_month}-${chatDetails?.start_year})`}>
          {chatDetails?.display_name} - {chatDetails?.company_college_name} ({chatDetails?.start_month}-{chatDetails?.start_year})
          <div onClick={() => {setTrigger(!Trigger)}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none">
                <path d="M2.02489 8.77512C2.53114 7.72512 3.24364 6.78762 4.04989 6.00012C4.85614 5.21262 5.77489 4.59387 6.74989 4.14387C7.72489 3.69387 8.73739 3.45012 9.73114 3.35637C10.7249 3.28137 11.7186 3.35637 12.6561 3.61887C13.5936 3.86262 14.4374 4.27512 15.1874 4.80012C15.6186 5.10012 16.0124 5.43762 16.3686 5.81262L13.3686 7.78137L20.8499 9.30012L22.3686 1.81887L19.8374 3.48762C19.4436 3.13137 19.0311 2.79387 18.5999 2.49387C16.5186 1.03137 13.9311 0.243869 11.1374 0.431369C4.93114 0.881369 0.243638 6.07512 0.393638 12.3001C0.412388 12.9564 0.487388 13.6126 0.599888 14.2501C0.618638 14.3626 0.768638 14.4189 0.862388 14.3626C0.918638 14.3064 0.956138 14.2501 0.937388 14.1939C0.824888 12.2814 1.21864 10.3876 2.02489 8.77512ZM23.1186 9.61887C23.0624 9.65637 23.0436 9.71262 23.0436 9.76887C23.1561 11.7001 22.7811 13.6126 21.9749 15.2064C21.4686 16.2564 20.7561 17.1939 19.9499 17.9814C19.1436 18.7689 18.2249 19.3876 17.2499 19.8376C16.2749 20.2876 15.2624 20.5314 14.2686 20.6251C13.2749 20.7001 12.2811 20.6251 11.3436 20.3626C10.4061 20.1189 9.54364 19.7064 8.79364 19.1814C8.36239 18.8814 7.98739 18.5439 7.63114 18.1876L10.6124 16.2189L3.13114 14.7001L1.61239 22.1814L4.14364 20.5126C4.51864 20.8689 4.93114 21.1876 5.36239 21.4876C7.46239 22.9689 10.0874 23.7564 12.8999 23.5501C19.1249 23.0814 23.7936 17.8689 23.5874 11.6251C23.5686 10.9689 23.4936 10.3501 23.3624 9.73137C23.3624 9.61887 23.2311 9.56262 23.1186 9.61887Z" fill="var(--AccentColor)"/>
            </svg>
          </div>
        </h3>
        {ShowDiscrepancyChat &&
          <button onClick={() => {setShowDiscrepancyChat(false)}}>Hide</button>
        }
        {(!ShowResume && ShowDiscrepancyChat) &&
          <button className='ViewResume' onClick={() => {setShowResume(true)}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="0.75rem" height="1rem" viewBox="0 0 14 17" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M3.99622 0.5H9.99678C12.4966 0.5 13.993 2.0608 14 4.668V12.332C14 14.94 12.5098 16.5 10.0038 16.5H7.78244C7.64387 16.4831 7.5162 16.4143 7.4238 16.3067C7.33141 16.1991 7.28078 16.0603 7.28156 15.9168C7.28097 15.7734 7.33169 15.6348 7.42406 15.5274C7.51644 15.42 7.644 15.3513 7.78244 15.3344H9.99678C11.907 15.3344 12.8691 14.324 12.8691 12.332V4.668C12.8691 2.676 11.907 1.6656 9.99678 1.6656H3.99622C2.086 1.6656 1.11767 2.676 1.11767 4.668V12.332C1.11767 14.324 2.086 15.3344 3.99544 15.3344C4.13402 15.3513 4.26169 15.4201 4.35408 15.5277C4.44648 15.6353 4.49711 15.7741 4.49633 15.9176C4.49694 16.0609 4.44633 16.1994 4.35411 16.3068C4.2619 16.4142 4.13453 16.4829 3.99622 16.5C1.49722 16.5 0 14.9392 0 12.332V4.668C0 2.0544 1.49722 0.5 3.99622 0.5ZM4.19222 5.6992H6.32567C6.46425 5.68229 6.59192 5.61348 6.68431 5.50591C6.7767 5.39834 6.82734 5.25953 6.82656 5.116C6.82717 4.97273 6.77655 4.83422 6.68434 4.72683C6.59212 4.61945 6.46475 4.55067 6.32644 4.5336H4.19222C4.05392 4.55067 3.92654 4.61945 3.83433 4.72683C3.74212 4.83422 3.6915 4.97273 3.69211 5.116C3.69131 5.25941 3.74184 5.39811 3.83407 5.50567C3.9263 5.61322 4.05379 5.68211 4.19222 5.6992ZM9.79378 9.0832H4.186C4.04742 9.06629 3.91975 8.99748 3.82736 8.88991C3.73497 8.78234 3.68433 8.64353 3.68511 8.5C3.68433 8.35647 3.73497 8.21766 3.82736 8.11009C3.91975 8.00252 4.04742 7.93371 4.186 7.9168H9.79378C9.89933 7.90499 10.006 7.92429 10.1013 7.97245C10.1966 8.02061 10.2766 8.09564 10.332 8.1888C10.388 8.28238 10.4177 8.39011 10.4177 8.5C10.4177 8.60989 10.388 8.71762 10.332 8.8112C10.2766 8.90436 10.1966 8.97939 10.1013 9.02755C10.006 9.07571 9.89933 9.09501 9.79378 9.0832ZM9.79378 12.4672H4.186C4.03761 12.4659 3.89578 12.4041 3.79166 12.2954C3.68753 12.1866 3.62963 12.0398 3.63067 11.8872C3.63067 11.5672 3.87956 11.308 4.186 11.308H9.79378C9.94203 11.3093 10.0837 11.371 10.1878 11.4795C10.2919 11.5881 10.3499 11.7347 10.3491 11.8872C10.3491 12.2072 10.1002 12.4672 9.79378 12.4672Z" fill="var(--AccentColor)"/>
            </svg>
            View Resume
          </button>
        }
      </header>
      <div className='ChatSection' ref={chatRef}>
        {Messages && Messages?.map((message, index) => (
          renderMessage(message, index)
        ))}
      </div>
      {Completed ?
        <div className='ChatEnded'>
          This discrepancy was closed as <b>{chatDetails?.conclusion_status}</b>
        </div>
        :
        !IsMaster && (
          <div className='MsgConclude'>
            <form className='MessageInput' onSubmit={(e) => {e.preventDefault(); submitMessage();}}>
              <input value={MessageInput} onChange={(e) => {setMessageInput(e.target.value);}}/>
              <button className='Send' type='submit' disabled={SendingMessage}>
                {SendingMessage ?
                  <ButtonSpinner/>
                  :
                  <>
                    Send
                    <svg xmlns="http://www.w3.org/2000/svg" width="0.75rem" height="0.75rem" viewBox="0 0 16 16" fill="none">
                      <g clipPath="url(#clip0_15563_69269)">
                        <mask id="mask0_15563_69269" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                          <path d="M16 0H0V16H16V0Z" fill="white"/>
                        </mask>
                        <g mask="url(#mask0_15563_69269)">
                          <path d="M2.05404 9.0877L6.72129 8.1542C7.13804 8.07095 7.13804 7.93545 6.72129 7.8522L2.05404 6.9187C1.77604 6.8632 1.50529 6.5922 1.44979 6.31445L0.51629 1.6472C0.43279 1.2302 0.67854 1.03645 1.06479 1.2147L15.307 7.78795C15.5643 7.9067 15.5643 8.0997 15.307 8.21845L1.06479 14.7917C0.67854 14.97 0.43279 14.7762 0.51629 14.3592L1.44979 9.69195C1.50529 9.4142 1.77604 9.1432 2.05404 9.0877Z" fill="white"/>
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_15563_69269">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </>
                }
              </button>
            </form>
          </div>
        )
      }
    </div>
  )
}

export default DiscrepancyChat